/* ANYSNIFF cart — drawer + Shopify AJAX Cart API.
 *
 * Wiring contract:
 *   [data-cart-open]        opens the drawer (the nav icon)
 *   [data-cart-close]       closes it (backdrop, X, Esc)
 *   [data-cart-count]       any element showing the item count
 *   form[data-add-to-cart]  intercepted, posted to /cart/add.js, opens the drawer
 *
 * Lenis is paused while the drawer is open, the same way the site pauses it for
 * the mobile nav — without that, the page scrolls behind the panel.
 */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  var panelBody = drawer.querySelector('[data-cart-lines]');
  var foot = drawer.querySelector('[data-cart-foot]');
  var emptyState = drawer.querySelector('[data-cart-empty]');
  /* Suma NIE jest zapamietywana przy starcie. Aplikacja punktow odbioru (Progus)
   * wpina sie w koszyk przez form[action="/cart"] i KLONUJE ten formularz: jeden
   * zostaje ukryty, drugi widoczny. Zapamietany przy starcie element trafial
   * wtedy w kopie ukryta, a widoczna zostawala z wartoscia sprzed dodania
   * produktu — przycisk do kasy pokazywal „0,00 zl" przy pozycji za 229 zl.
   * Dlatego szukamy za kazdym razem i aktualizujemy WSZYSTKIE wystapienia. */
  function setTotal(text) {
    drawer.querySelectorAll('[data-cart-total]').forEach(function (el) { el.textContent = text; });
  }
  var tpl = document.getElementById('cart-line-template');
  var moneyFormat = drawer.getAttribute('data-money-format') || '{{amount}} zł';
  var pageCurrency = drawer.getAttribute('data-currency') || '';
  var routeBase = (drawer.getAttribute('data-cart-url') || '/cart').replace(/\/cart$/, '');

  /* ---------- money ---------- */
  /* Format waluty pochodzi z HTML-a wyrenderowanego przy wejsciu na strone, a kwoty
   * z /cart.js. Gdy Shopify przeliczy koszyk na inny rynek, te dwa zrodla sie
   * rozjezdzaja i wychodzi kwota w jednej walucie z symbolem drugiej — „£229.00"
   * zamiast „£52.00". Przy rozjezdzie formatujemy z waluty koszyka, wiec symbol
   * i liczba zawsze pochodza z tej samej odpowiedzi. */
  function formatMoney(cents, currency) {
    var value = (cents || 0) / 100;
    if (currency && pageCurrency && currency !== pageCurrency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: currency
        }).format(value);
      } catch (err) { /* nieznany kod waluty — spadamy do formatu ze sklepu */ }
    }
    function withDelims(num, thousands, decimal, places) {
      var parts = num.toFixed(places).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount':                                 return withDelims(value, ',', '.', 2);
        case 'amount_with_comma_separator':            return withDelims(value, '.', ',', 2);
        case 'amount_with_space_separator':            return withDelims(value, ' ', ',', 2);
        case 'amount_no_decimals':                     return withDelims(value, ',', '.', 0);
        case 'amount_no_decimals_with_comma_separator':return withDelims(value, '.', ',', 0);
        case 'amount_no_decimals_with_space_separator':return withDelims(value, ' ', ',', 0);
        default:                                       return withDelims(value, ',', '.', 2);
      }
    });
  }

  /* Rozjazd walut znaczy, ze nieaktualny jest caly HTML — ceny w sekcjach, „dorzuc
   * do koszyka", nota o dostawie — a nie sama szuflada. Przeladowujemy strone raz,
   * z blokada w sessionStorage, zeby nie wpasc w petle, gdy rozjazd sie utrzyma. */
  function currencyDrifted(cart) {
    if (!cart.currency || !pageCurrency || cart.currency === pageCurrency) return false;
    try {
      if (sessionStorage.getItem('anysniff:currency') !== cart.currency) {
        sessionStorage.setItem('anysniff:currency', cart.currency);
        window.location.reload();
        return true;
      }
    } catch (err) { /* brak sessionStorage — lecimy dalej na Intl */ }
    return false;
  }

  /* ---------- open / close ---------- */
  function open() {
    drawer.hidden = false;
    // Force a reflow so the transform transition has a starting frame. Using
    // requestAnimationFrame here would leave the drawer stuck shut whenever the
    // browser throttles rAF (background tab, hidden pane).
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    if (window.lenis) window.lenis.stop();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (window.lenis) window.lenis.start();
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 450);
  }

  function onKey(e) { if (e.key === 'Escape') close(); }

  /* ---------- render ---------- */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  function render(cart) {
    if (currencyDrifted(cart)) return;
    setCount(cart.item_count);
    panelBody.querySelectorAll('[data-cart-line]').forEach(function (n) { n.remove(); });

    if (!cart.items.length) {
      if (emptyState) emptyState.hidden = false;
      if (foot) foot.hidden = true;
      /* Suma tez musi zejsc do zera. Stopka jest wtedy schowana, wiec stara
       * wartosc nie razi od razu — ale zostaje w DOM i wraca w ulamku sekundy
       * miedzy pokazaniem stopki a nastepnym renderem, gdy klient znowu cos
       * doda. Zerujemy od razu, zamiast liczyc na kolejność zdarzen. */
      setTotal(formatMoney(0, cart.currency));
      return;
    }
    if (emptyState) emptyState.hidden = true;
    if (foot) foot.hidden = false;
    setTotal(formatMoney(cart.total_price, cart.currency));

    cart.items.forEach(function (item, i) {
      var row = tpl.content.firstElementChild.cloneNode(true);
      var key = item.key;
      row.setAttribute('data-key', key);
      row.setAttribute('data-index', i + 1);

      row.querySelectorAll('[data-line-url]').forEach(function (a) { a.href = item.url; });
      row.querySelector('[data-line-title]').textContent = item.product_title || item.title;

      var variant = row.querySelector('[data-line-variant]');
      var isDefault = !item.variant_title || item.variant_title === 'Default Title';
      if (isDefault) variant.remove(); else variant.textContent = item.variant_title;

      var img = row.querySelector('[data-line-image]');
      /* Produkt bez zdjęć w Shopify zostawiał puste miejsce po miniaturze i rozjeżdżał
       * siatkę linii. Zapasowy plik z motywu trzyma layout do czasu wgrania zdjęć. */
      var fallback = drawer.getAttribute('data-fallback-image');
      if (item.image) {
        img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2');
        img.alt = item.product_title || '';
      } else if (fallback) {
        img.src = fallback;
        img.alt = '';
      } else {
        row.querySelector('.cart_line-media').remove();
      }

      row.querySelector('[data-line-qty]').textContent = item.quantity;
      /* Cena przekreslona przy promocji: cart.js nie zwraca compare_at_price, wiec
       * mape wariant -> cena przed obnizka (w walucie rynku) daje Liquid w data-compare. */
      var linePrice = row.querySelector('[data-line-price]');
      var cmpMap = {};
      try { cmpMap = JSON.parse(drawer.getAttribute('data-compare') || '{}'); } catch (err) {}
      var cmp = cmpMap[item.variant_id];
      linePrice.textContent = '';
      if (cmp && cmp > item.price) {
        var old = document.createElement('s');
        old.className = 'price_old';
        old.textContent = formatMoney(cmp * item.quantity, cart.currency);
        linePrice.appendChild(old);
        linePrice.appendChild(document.createTextNode(' '));
      }
      linePrice.appendChild(document.createTextNode(formatMoney(item.final_line_price, cart.currency)));

      row.querySelector('[data-line-minus]').addEventListener('click', function () { change(key, item.quantity - 1); });
      row.querySelector('[data-line-plus]').addEventListener('click', function () { change(key, item.quantity + 1); });
      row.querySelector('[data-line-remove]').addEventListener('click', function () { change(key, 0); });

      panelBody.appendChild(row);
    });

    syncQuickAdd(cart);
  }

  /* Wariant, który już leży w koszyku, znika z listy „dorzuć" — inaczej sekcja
   * powtarza to, co użytkownik przed chwilą dodał, i puchnie na całą szufladę. */
  function syncQuickAdd(cart) {
    var block = drawer.querySelector('.cart_quickadd');
    if (!block) return;
    var inCart = {};
    cart.items.forEach(function (i) { inCart[String(i.variant_id || i.id)] = true; });

    var shown = 0;
    block.querySelectorAll('.cart_quickadd-item').forEach(function (form) {
      var input = form.querySelector('input[name="id"]');
      var hide = input && inCart[String(input.value)];
      form.hidden = !!hide;
      if (!hide) shown++;
    });
    block.hidden = shown === 0;
  }

  /* ---------- Shopify AJAX Cart API ---------- */
  function busy(on) { drawer.classList.toggle('is-busy', !!on); }

  function refresh() {
    return fetch(routeBase + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.json();
      })
      .then(function (cart) { render(cart); return cart; })
      .catch(function (err) {
        // Never let a failed fetch block the UI — the drawer still opens and
        // shows whatever was server-rendered. (Also what happens in the static
        // preview, where /cart.js does not exist.)
        console.warn('[anysniff cart] refresh failed:', err.message);
        return null;
      });
  }

  function change(key, quantity) {
    busy(true);
    return fetch(routeBase + '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); })
      .catch(function () { /* leave the drawer as-is; the next refresh corrects it */ })
      .finally(function () { busy(false); });
  }

  function add(formData, button) {
    busy(true);
    if (button) button.setAttribute('aria-busy', 'true');
    return fetch(routeBase + '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'add failed'); });
        return r.json();
      })
      .then(function () { return refresh(); })
      .then(function () { open(); })
      .catch(function (err) {
        var msg = drawer.querySelector('[data-cart-error]');
        if (msg) msg.textContent = err.message;
        else console.warn('[anysniff cart]', err.message);
      })
      .finally(function () { busy(false); if (button) button.removeAttribute('aria-busy'); });
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refresh().then(open); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[data-add-to-cart]') : null;
    if (!form) return;
    e.preventDefault();
    add(new FormData(form), form.querySelector('[type="submit"]'));
  });


  /* ---------- quantity steppers (drawer + product page) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-qty-minus],[data-qty-plus]');
    if (!btn) return;
    e.preventDefault();
    var input = btn.parentElement.querySelector('input[name="quantity"]')
      || (btn.closest('form') && btn.closest('form').querySelector('input[name="quantity"]'));
    if (!input) return;
    var min = parseInt(input.min || '1', 10);
    var val = parseInt(input.value, 10);
    if (isNaN(val)) val = min;
    val += btn.hasAttribute('data-qty-plus') ? 1 : -1;
    input.value = Math.max(min, val);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- header price follows the colour tabs ---------- */
  document.addEventListener('anysniff:tabchange', function (e) {
    var el = document.querySelector('[data-prod-price]');
    if (!el) return;
    var map;
    try { map = JSON.parse(el.getAttribute('data-prices') || '{}'); } catch (err) { return; }
    var price = map[e.detail.tab];
    if (!price) return;                                  // already money-formatted by Liquid
    var cmp = {};
    try { cmp = JSON.parse(el.getAttribute('data-compare') || '{}'); } catch (err) {}
    var old = cmp[e.detail.tab];
    el.textContent = '( ';
    if (old) {
      var s = document.createElement('s');
      s.className = 'price_old';
      s.textContent = old;
      el.appendChild(s);
      el.appendChild(document.createTextNode(' '));
    }
    el.appendChild(document.createTextNode(price + ' )'));
  });

  // Keep the badge honest on load (cached pages, back-button restores).
  refresh();

  /* ---------- powrot do otwartej szuflady po zmianie jezyka lub waluty ------
   * Przelaczniki w stopce szuflady wysylaja formularz `localization`, ktory
   * przeladowuje strone — a po przeladowaniu szuflada bylaby zamknieta i klient
   * wypadalby z koszyka w polowie zakupu. Zaznaczamy zamiar przed wyslaniem
   * i otwieramy ja po powrocie.
   *
   * sessionStorage, nie parametr w adresie: adres zostaje czysty, a znacznik
   * ginie razem z karta. Kasujemy go od razu po odczycie, zeby szuflada nie
   * otwierala sie przy kazdym kolejnym wejsciu. */
  var ZNACZNIK_POWROTU = 'anysniff:reopen-cart';

  drawer.addEventListener('submit', function (e) {
    if (e.target.closest && e.target.closest('.cart_locale')) {
      try { sessionStorage.setItem(ZNACZNIK_POWROTU, '1'); } catch (err) { /* tryb prywatny */ }
    }
  });

  try {
    if (sessionStorage.getItem(ZNACZNIK_POWROTU)) {
      sessionStorage.removeItem(ZNACZNIK_POWROTU);
      refresh().then(open);
    }
  } catch (err) { /* brak sessionStorage — szuflada po prostu zostanie zamknieta */ }

})();

/* ---------- Dopisek pod przyciskiem: kreska nie wisi na koncu wiersza ----------
 * snippets/wf-delivery-note sklada dopisek z segmentow (.seg), kreske rysuje CSS.
 * Segment, po ktorym kolejny zaczyna nowy wiersz, dostaje .is-line-end i jego
 * kreska znika (visibility, wiec szerokosc sie nie zmienia i nic nie przeskakuje).
 * ResizeObserver lapie zmiane szerokosci, ladowanie fontu i pokazanie panelu
 * innego koloru (ukryty panel ma zerowe wymiary). */
(function () {
  function mark(note) {
    var segs = note.querySelectorAll('.seg');
    for (var i = 0; i < segs.length; i++) {
      var a = segs[i].getClientRects(), b = segs[i + 1] ? segs[i + 1].getClientRects() : null;
      var end = !b || !a.length || !b.length ? false : b[0].top > a[a.length - 1].top + 2;
      segs[i].classList.toggle('is-line-end', end);
    }
  }
  function init() {
    var notes = document.querySelectorAll('.note');
    if (!notes.length) return;
    var ro = window.ResizeObserver ? new ResizeObserver(function (en) { en.forEach(function (e) { mark(e.target); }); }) : null;
    notes.forEach(function (n) { mark(n); if (ro) ro.observe(n); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { notes.forEach(mark); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ---------- Desktop, strona produktu: nawigacja za sekcja produktu ----------
 * Kolumna ze zdjeciem przykleja sie przez cala sekcje produktu. Gdy jej dol
 * minie gorny pas ekranu (120 px — tam stoi plywajacy KOSZYK), body dostaje
 * `is-past-prod`: koszyk gasnie, wjezdza zwykla nawigacja (CSS w overrides). */
(function () {
  var col = document.querySelector('.template-product .prod_column.is-images');
  if (!col || !window.IntersectionObserver) return;
  new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      document.body.classList.toggle('is-past-prod', !e.isIntersecting && e.boundingClientRect.top < 0);
    });
  }, { rootMargin: '-120px 0px 0px 0px' }).observe(col);
})();

/* ---------- Wysokosc paska miniatur galerii jako zmienna CSS (--strip-h) ----------
 * Ponizej 992 px zdjecie konczy sie nad paskiem miniatur z tym samym odstepem
 * nad i pod nim (1em) — do tego potrzebna jest faktyczna wysokosc paska. */
(function () {
  var box = document.querySelector('.prod_images'), strip = box && box.querySelector('.prod_images-thumbs-wrap');
  if (!strip) return;
  function set() { box.style.setProperty('--strip-h', strip.getBoundingClientRect().height + 'px'); }
  set();
  if (window.ResizeObserver) new ResizeObserver(set).observe(strip);
  window.addEventListener('resize', set);
})();

/* ---------- Wysokosc paska zakupu jako zmienna CSS (--bar-h) ----------
 * Galeria ponizej 992 px dobiera wysokosc do miejsca nad paskiem. Gdy pasek nie
 * jest przyklejony (telefon w poziomie) albo ukryty — 0. */
(function () {
  var bar = document.querySelector('.cta_sticky');
  if (!bar) return;
  function set() {
    var cs = getComputedStyle(bar);
    var on = cs.display !== 'none' && (cs.position === 'sticky' || cs.position === 'fixed');
    document.documentElement.style.setProperty('--bar-h', on ? bar.getBoundingClientRect().height + 'px' : '0px');
  }
  set();
  if (window.ResizeObserver) new ResizeObserver(set).observe(bar);
  window.addEventListener('resize', set);
})();
